<admin-layout [showSearch]="false" [showMenu]="false" [showActionBar]="false">
    <header class="controller-bar">
        <button type="button" class="back" (click)="onCancel()" aria-label="Voltar">
            <mat-icon>west</mat-icon>
        </button>
        <div class="controller-avatar" aria-hidden="true">{{ initials }}</div>
        <div class="controller-meta">
            <h1>{{ isEditState ? (entityForEdit?.name || 'Controlador') : 'Novo controlador' }}</h1>
            <p>
                @if (isEditState && entityForEdit?.code) {
                <span class="code">{{ entityForEdit.code }}</span>
                } @else {
                <span>Cadastro</span>
                }
                @if (isEditState && entityForEdit?.email) {
                <span class="dot">·</span>
                <span class="mail">{{ entityForEdit.email }}</span>
                }
                @if (isEditState) {
                <span class="chip" [class.off]="entityForEdit?.active === false">{{
                    entityForEdit?.active === false ? 'Inativo' : 'Ativo'
                }}</span>
                }
            </p>
        </div>
    </header>

    <div class="content-area">
        <app-controller-details
            #detailsForm
            [entity]="entityForEdit"
            (formSubmit)="onSave($event)"
        ></app-controller-details>
    </div>
</admin-layout>
